import { Components, Theme } from '@mui/material';

export const MuiFormHelperText = {
  defaultProps: {
    component: 'div'
  },
  styleOverrides: {
    root: ({ theme }) => ({
      marginLeft: theme.spacing(1),
      marginRight: 0,
      marginTop: theme.spacing(0.5),
      ...theme.typography.caption,
      color: theme.palette.neutral.onSurfaceVariant,
      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      }
    }),
  }
} as Components<Theme>['MuiFormHelperText'];